(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accessibility"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.IllumibiteA11yWidgetInitialized) {
    return;
  }

  window.IllumibiteA11yWidgetInitialized = true;

  const STORAGE_KEY = 'illumibite-a11y';
  const DEFAULT_STATE = {
    text: 'normal',
    visual: 'default',
    links: 'default'
  };

  const VALID_VALUES = {
    text: ['normal', 'large', 'xlarge'],
    visual: ['default', 'invert', 'high-saturation', 'low-saturation', 'desaturate'],
    links: ['default', 'underline']
  };

  const normalizeState = (state) => {
    const next = { ...DEFAULT_STATE, ...state };
    Object.keys(VALID_VALUES).forEach((key) => {
      if (!VALID_VALUES[key].includes(next[key])) {
        next[key] = DEFAULT_STATE[key];
      }
    });
    return next;
  };

  const readState = () => {
    try {
      const raw = window.localStorage.getItem(STORAGE_KEY);
      if (raw) {
        return normalizeState(JSON.parse(raw));
      }
    } catch (error) {
      return { ...DEFAULT_STATE };
    }

    const state = { ...DEFAULT_STATE };
    return state;
  };

  const saveState = (state) => {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch (error) {
      // Ignore storage errors
    }
  };

  const applyState = (state) => {
    const root = document.documentElement;
    const applyAttr = (attr, value, defaultValue) => {
      if (value === defaultValue) {
        root.removeAttribute(attr);
      } else {
        root.setAttribute(attr, value);
      }
    };

    applyAttr('data-a11y-text', state.text, 'normal');
    applyAttr('data-a11y-visual', state.visual, 'default');
    applyAttr('data-a11y-links', state.links, 'default');
  };

  const updateWidget = (widget, state) => {
    const inputs = widget.querySelectorAll('input[data-a11y-setting]');
    inputs.forEach((input) => {
      const setting = input.dataset.a11ySetting;
      if (setting && state[setting] !== undefined) {
        input.checked = input.value === state[setting];
      }
    });
  };

  const initWidget = (widget, getState, updateAll) => {
    const toggle = widget.querySelector('[data-a11y-toggle]');
    const panel = widget.querySelector('[data-a11y-panel]');
    const closeButton = widget.querySelector('[data-a11y-close]');
    const resetButton = widget.querySelector('[data-a11y-reset]');

    const openPanel = () => {
      if (!panel || !toggle) return;
      panel.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      const focusTarget = panel.querySelector('input, button');
      if (focusTarget) {
        focusTarget.focus();
      }
    };

    const closePanel = () => {
      if (!panel || !toggle) return;
      panel.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
    };

    if (toggle) {
      toggle.addEventListener('click', () => {
        if (!panel) return;
        if (panel.hidden) {
          openPanel();
        } else {
          closePanel();
        }
      });
    }

    if (closeButton) {
      closeButton.addEventListener('click', closePanel);
    }

    if (resetButton) {
      resetButton.addEventListener('click', () => {
        const nextState = { ...DEFAULT_STATE };
        saveState(nextState);
        applyState(nextState);
        updateAll(nextState);
      });
    }

    widget.addEventListener('change', (event) => {
      const target = event.target;
      if (!(target instanceof HTMLInputElement)) return;
      const setting = target.dataset.a11ySetting;
      if (!setting) return;

      const currentState = getState();
      const nextState = normalizeState({ ...currentState, [setting]: target.value });
      saveState(nextState);
      applyState(nextState);
      updateAll(nextState);
    });

    document.addEventListener('click', (event) => {
      if (!panel || panel.hidden) return;
      if (!widget.contains(event.target)) {
        closePanel();
      }
    });

    widget.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      if (panel && !panel.hidden) {
        event.stopPropagation();
        closePanel();
        if (toggle) {
          toggle.focus();
        }
      }
    });

    if (widget.dataset.a11yDefaultOpen === 'true') {
      openPanel();
    } else {
      closePanel();
    }
  };

  const init = () => {
    const widgets = Array.from(document.querySelectorAll('[data-a11y-widget]'));
    if (widgets.length === 0) return;

    let state = readState();
    applyState(state);

    const updateAll = (nextState) => {
      state = nextState;
      widgets.forEach((widget) => updateWidget(widget, state));
    };

    const getState = () => state;

    widgets.forEach((widget) => {
      updateWidget(widget, state);
      initWidget(widget, getState, updateAll);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
